import { Dispatch, SetStateAction } from "react";
import * as Style from "./MarketingMaterialsToolbar.styles.ts";
import MarketingMaterialsFilters from "../MarketingMaterialsFilters/MarketingMaterialsFilters.tsx";
import { SortOption } from "../../marketingMaterialsConstants.ts";
import { models } from "../../../../../types/api/viewModels.ts";

export interface MarketingMaterialsToolbarProps {
	filterOptions: MarketingMaterialsFilterOpts;
	setFilterOptions: Dispatch<SetStateAction<MarketingMaterialsFilterOpts>>;
	merchandiseFilters?: models["MerchandiseProductFilterDto"] | null;
	onFiltersChanged: (nextFilterOptions: MarketingMaterialsFilterOpts) => void;
}

export const MarketingMaterialsToolbar = ({
	filterOptions,
	setFilterOptions,
	merchandiseFilters,
	onFiltersChanged
}: MarketingMaterialsToolbarProps) => {
	return (
		<Style.MarketingMaterialsPageToolbarContainer data-testid="lead-assignments-toolbar">
			<Style.MarketingMaterialsPageFilterContainer>
				<MarketingMaterialsFilters
					filterOptions={filterOptions}
					setFilterOptions={setFilterOptions}
					merchandiseFilters={merchandiseFilters}
					onFiltersChanged={onFiltersChanged}
				/>
			</Style.MarketingMaterialsPageFilterContainer>
		</Style.MarketingMaterialsPageToolbarContainer>
	);
};

export interface MarketingMaterialsFilterOpts {
	channel?: string[];
	brandAndProductLine?: string[];
	category?: string[];
	type?: string[];
	availability?: string[];
	sort: SortOption;
}
